<template>
  <el-card class="h-full ">
    <div class="h-full flex flex-col">
      <div class="flex justify-between items-center">
        <!-- <span class="border-l-3 border-color-primary pl-10px text-18px">一队一册信息</span> -->
        <div>
          <el-page-header @back="goBack" content="一队一册信息"> </el-page-header>
        </div>
        <el-button
          size="small"
          type="primary"
          @click="exportExcel"
          v-if="activeModule === 'companyQualifications'"
          >导出</el-button
        >
      </div>

      <el-tabs v-model="activeModule">
        <el-tab-pane
          v-for="item in moduleShowList"
          :key="item.module"
          :label="item.moduleName"
          :name="item.module"
        ></el-tab-pane>
      </el-tabs>
      <!-- v-if="contractorId" -->
      <div class="w-full flex-1 overflow-y-auto">
        <!-- 基本信息 -->
        <CompanyQualifications
          v-if="activeModule === 'companyQualifications'"
          :workPermitId="workPermitId"
          :contractorId="contractorId"
        />
        <PersonnelDirectory
          v-if="activeModule === 'personnelDirectory'"
          :contractorId="contractorId"
        />
        <ToolsDiretory
          v-if="activeModule === 'toolDirectory'"
          :orgId="orgId"
          :contractorId="contractorId"
        />
        <TrainingRecord
          v-if="activeModule === 'trainingRecord'"
          :orgId="orgId"
          :contractorId="contractorId"
        />
        <SuspiciousDeparture
          v-if="activeModule === 'suspiciousDeparture'"
          :contractorId="contractorId"
          :orgName="orgName"
        />
      </div>
    </div>
  </el-card>
</template>
<script>
import { ContractorAccountRelationApi, ContractorApi } from '@wiz-api/contractor-management'

import CompanyQualifications from './companyQualifications/index'
import PersonnelDirectory from './personnelDirectory/index'
import ToolsDiretory from './toolsDirectory/index'
import TrainingRecord from './trainingRecord/index'
import SuspiciousDeparture from './suspiciousDeparture/index'

const contractorAccountRelationApi = new ContractorAccountRelationApi()
const contractorApi = new ContractorApi()
export default {
  components: {
    CompanyQualifications,
    PersonnelDirectory,
    ToolsDiretory,
    TrainingRecord,
    SuspiciousDeparture,
  },
  data() {
    return {
      orgId: '',
      contractorId: '',
      workPermitId: '',
      activeModule: 'companyQualifications',
      moduleShowList: [
        {
          module: 'companyQualifications',
          moduleName: '公司资质',
        },
        {
          module: 'personnelDirectory',
          moduleName: '人员名册',
        },
        {
          module: 'toolDirectory',
          moduleName: '工器具名册',
        },
        {
          module: 'trainingRecord',
          moduleName: '培训记录',
        },
        {
          module: 'suspiciousDeparture',
          moduleName: '疑似离厂情况',
        },
      ],
    }
  },
  async mounted() {
    this.workPermitId = this.$route.query.workPermitId
    this.contractorId = this.$route.query.workPermitId
    this.orgId = this.$route.query.orgId
    this.orgName = decodeURIComponent(this.$route.query.orgName)
    // this.getContractorInfo()
  },
  methods: {
    // async getContractorInfo() {
    //   // 拿承包商id和模板id
    //   const [err, res] = await contractorAccountRelationApi.getContractorAccountRelationByUserDto()
    //   if (!err) {
    //     this.contractorId = res.contractorId
    //   }
    // },
    goBack() {
      this.$router.go(-1)
    },
    async exportExcel() {
      const fileName = '下载文件'
      const [err, data] = await contractorApi.exportFileExcel(this.contractorId)
      if (err) {
        return
      }

      // 文件流下载
      const blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `${fileName}`
      link.click()
      window.URL.revokeObjectURL(link.href)
    },
  },
}
</script>
<style scoped lang="scss">
::v-deep .el-card__body {
  height: 100%;
}
</style>
